import { render } from "./vendors_import.vue?vue&type=template&id=2f3847e5&scoped=true"
import script from "./vendors_import.vue?vue&type=script&lang=js"
export * from "./vendors_import.vue?vue&type=script&lang=js"

import "./vendors_import.vue?vue&type=style&index=0&id=2f3847e5&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3847e5"]])

export default __exports__